import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IDynamicControlModel } from '../dynamic-control-model';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ITags } from '../../features/bucket-items/models/bucket-item.model';
import { MatFormField, MatInput, MatSuffix } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'app-single-select-with-search',
    templateUrl: './single-select-with-search.component.html',
    styleUrls: ['./single-select-with-search.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatSelect, MatInput, MatSuffix, MatOption, MatIconButton, MatTooltip]
})
export class SingleSelectWithSearchComponent implements OnInit {
  @Input() public tag:Partial<IDynamicControlModel>
  @Input() public initialValue:string
  @Input() public disabled:boolean = false
  @Input() public idPrefix?:string
  @Output() public selectedValue:EventEmitter<Partial<ITags>> = new EventEmitter<Partial<ITags>>();

  public filteredOptions:string[];

  public controlForm:FormGroup = new FormGroup({
    tagValue:new FormControl(''),
    search:new FormControl('')
  });

  private readonly defaultIdPrefix = 'bucket-items-tags-tag-unknown';

  public ngOnInit(): void {
    this.initForm();
    if(this.disabled){
      this.controlForm.disable();
    }

    this.controlForm.get("tagValue").valueChanges.subscribe(selected=>{
      this.selectedValue.emit({TagKey:this.tag.TagKey,TagValue:selected,TagsDisplayOrder:this.tag.TagsDisplayOrder});
    })
    this.filteredOptions=[...this.tag.TagValues]
  }

  initForm(){
    this.controlForm.get("tagValue").patchValue(this.initialValue);
  }
  applyFilters(searchText:string){
    this.filteredOptions = this.tag.TagValues.filter(item => item.toLowerCase().includes(searchText.toLowerCase()));
  }

  clearContent(){
    if(this.disabled){
      return;
    }
    this.controlForm.get("tagValue").patchValue("");
  }

  clearSearch():void{
    if(this.disabled){
      return;
    }
    this.controlForm.get("search").patchValue('');
    this.filteredOptions=[...this.tag.TagValues];
  }

  public buildElementId(segment:string):string{
    const base = this.idPrefix && this.idPrefix.trim().length > 0 ? this.idPrefix.trim() : this.defaultIdPrefix;
    return `${base}-${segment}`;
  }
}
